import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { createGolNonContentDataAttributes } from '../../../helpers/tracking'
import { trackEvent } from '../../../helpers/ComponentHelper'
import * as Styled from './video-renderer.styles'

const VideoRenderer = ({ videoId, ratio, noCookie, type }) => {
  const [videoLoaded, setVideoLoaded] = useState(false)

  const addGolTracking = (e) => {
    const dataAttributes = createGolNonContentDataAttributes('link', 'initiate play', 'video', `${type}`, 'interaction')
    Object.keys(dataAttributes).forEach((attribute) =>
      e.currentTarget.setAttribute(attribute, dataAttributes[attribute])
    )
  }

  const loadVideo = (e) => {
    setVideoLoaded(true)
    addGolTracking(e)
    trackEvent(
      {
        eventInfo: {
          eventName: 'cmsVideoInteraction',
          eventAction: 'cms interaction'
        }
      },
      window
    )
  }

  if (!videoId) return null
  const VideoContainer = ratio === '3-by-2' ? Styled.ThreeByTwoContainer : Styled.Container
  const PlayerPlaceholder = ratio === '3-by-2' ? Styled.PlayerPlaceholder3by2 : Styled.PlayerPlaceholder
  const playerId = `yt-player--${videoId}`
  const videoParams =
    'autoplay=1&cc_load_policy=1&rel=0&modestbranding=1&showinfo=0&enablejsapi=1&origin=https://argos.co.uk'

  const videoSrc = `https://www.youtube${noCookie ? '-nocookie' : ''}.com/embed/${videoId}?${videoParams}`

  const videoPlaceholder = { backgroundImage: `url('https://img.youtube.com/vi/${videoId}/sddefault.jpg')` }
  if (!videoLoaded) {
    return (
      <VideoContainer data-test='video-renderer-container'>
        <PlayerPlaceholder
          data-test='video-renderer-player-wrapper'
          tabIndex='0'
          role='button'
          onClick={(e) => loadVideo(e)}
          onKeyPress={(e) => loadVideo(e)}
          style={videoPlaceholder}
        >
          <Styled.PlayButton data-test='video-renderer-playButton' />
        </PlayerPlaceholder>
      </VideoContainer>
    )
  }
  return (
    <VideoContainer data-test='video-renderer-container'>
      <Styled.PlayerPlaceholder data-test='video-renderer-player-wrapper'>
        <Styled.IFrame
          data-test='video-renderer-player-iframe'
          title={`play video - ${playerId}`}
          allow='autoplay'
          id={playerId}
          type='text/html'
          src={videoSrc}
          frameBorder='0'
        />
      </Styled.PlayerPlaceholder>
    </VideoContainer>
  )
}

VideoRenderer.defaultProps = {
  noCookie: true,
  ratio: '16-by-9',
  type: 'M050'
}

VideoRenderer.propTypes = {
  noCookie: PropTypes.bool,
  ratio: PropTypes.string,
  videoId: PropTypes.string,
  type: PropTypes.string
}

export default VideoRenderer
